import React from "react";
import PropTypes from "prop-types";
import { Box, Center, Image, Pressable, Text } from "native-base";
import seatAvailable from "../../assets/icons/seat-available.svg";
import seatBlocked from "../../assets/icons/seat-blocked.svg";
import seatSelected from "../../assets/icons/seat-selected.svg";
import colors from "../../constants/colors";

function Seat(props) {
  const { isBlocked, isSelected, isEmpty, position, disabled, onSelect } =
    props;

  if (isEmpty) {
    return <Box width={30} height={30} />;
  }

  return (
    <Pressable
      position="relative"
      onPress={() => onSelect(position)}
      disabled={disabled || isBlocked}
      _disabled={{ opacity: 1 }}>
      <Center>
        {isBlocked ? (
          <Image source={seatBlocked} width={30} height={30} alt="seat" />
        ) : (
          isSelected && (
            <Image source={seatSelected} width={30} height={30} alt="seat" />
          )
        )}
        {!isBlocked && !isSelected && (
          <Image source={seatAvailable} width={30} height={30} alt="seat" />
        )}
        <Text
          position="absolute"
          fontSize="xs"
          color={isSelected ? colors.white : colors.text}>
          {position}
        </Text>
      </Center>
    </Pressable>
  );
}

Seat.propTypes = {
  isBlocked: PropTypes.bool,
  isSelected: PropTypes.bool,
  isEmpty: PropTypes.bool,
  position: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
};

Seat.defaultProps = {
  isBlocked: false,
  isSelected: false,
  isEmpty: false,
  disabled: false,
};

export default React.memo(Seat);
